import { render } from "./WorldHotIndicator.vue?vue&type=template&id=507cb5ae&scoped=true"
import script from "./WorldHotIndicator.vue?vue&type=script&lang=js"
export * from "./WorldHotIndicator.vue?vue&type=script&lang=js"

import "./WorldHotIndicator.vue?vue&type=style&index=0&id=507cb5ae&scoped=true&lang=scss"
import "./WorldHotIndicator.vue?vue&type=style&index=1&id=507cb5ae&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507cb5ae"]])

export default __exports__